<template>
  <div class="page">
    <Quicksearch v-bind:searching.sync="searching" v-bind:callback="callback"/>
    <div class="container container-nopaddinghorizontal container-afterheader container-includestaticfooter">      
        <transition name="container-overlay">
            <div class="container-overlay" v-if="searching"></div>      
        </transition>
        <div class="container container-small page-content">   
            <h1>Fehler / Error / Erreur</h1>
            <div>
                <p>Die Seite wurde nicht gefunden. Bitte navigieren sie zur <router-link class="decorated" :to="'/'">Startseite</router-link>.</p>
                <p>Your requested page does not exist. Please navigate back to the <router-link class="decorated" :to="'/'">start page</router-link>.</p>
            </div>
        </div>
    </div>
    <StaticFooter/>
  </div>
</template>

<style lang="scss">
  @import "../main";
  .page {
      &-content {
          & > h1 {
              margin-top: $base-size * 2;
          }
          & > div {
              max-width: 660px;
              hyphens: auto;
              text-align: justify;
          }
      }
  }

</style>

<script>

import Quicksearch from '@/components/Quicksearch.vue'
import StaticFooter from '@/components/StaticFooter.vue'


export default {
  name: 'page',
  components: {
      Quicksearch,
      StaticFooter
  },
  data() {
    return {
        searching: false,
    }
  },
  methods: {
    callback() {
        this.$router.push({ name: 'searchresults' })
    },
  }
}
</script>
